import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'
import { ShareFileParams, ShareFolderParams } from './shared/types'

export function useShareFile() {
  const { server } = useServer()
  const client = useQueryClient()
  return useMutation({
    mutationFn: shareFile,
    onSuccess: async (data, variables, context) => {
      for (const chatGroupId of variables.chatGroupIdList) {
        const chatGroupFolderKey = keys.sharedChatGroupFolder(chatGroupId)
        await client.invalidateQueries({ queryKey: chatGroupFolderKey })
      }
    },
  })

  async function shareFile({
    fileId,
    chatGroupIdList,
    memberIdList,
    body,
    requireAcknowledgement,
    requireSignature,
    statement,
    dueDate,
  }: ShareFileParams) {
    const url = `/v2/chat/repository/files/${fileId}/share`
    await server.post(url, {
      chat_group_ids: chatGroupIdList ?? [],
      member_ids: memberIdList ?? [],
      body,
      require_acknowledgement: requireAcknowledgement,
      require_sign: requireSignature,
      statement,
      due_date: dueDate ? new Date(dueDate).getTime() : undefined,
    })
  }
}

export function useShareFolder() {
  const { server } = useServer()
  const client = useQueryClient()
  return useMutation({
    mutationFn: shareFolder,
    onSuccess: async (data, variables, context) => {
      for (const chatGroupId of variables.chatGroupIdList) {
        const chatGroupFolderKey = keys.sharedChatGroupFolder(chatGroupId)
        await client.invalidateQueries({ queryKey: chatGroupFolderKey })
      }
    },
  })

  async function shareFolder({
    folderId,
    chatGroupIdList,
    memberIdList,
    body,
  }: ShareFolderParams) {
    const url = `/v2/chat/repository/folders/${folderId}/share`
    await server.post(url, {
      chat_group_ids: chatGroupIdList ?? [],
      member_ids: memberIdList ?? [],
      body,
    })
  }
}
